export enum AddonFormType {
  OwnUse = 1,
  Resell = 2,
}
